import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import { OrderBy } from "@/@types/generics/OrderBy";

type Props<T> = OrderBy<T> & {
	handleChangeOrder: (property: keyof T) => void;
};

export function OrderByButton<T>({ handleChangeOrder, method, property, ...rest }: Props<T>) {
	return (
		<button
			className="d-flex border border-none bg-white flex-column fs-9 cursor-pointer"
			onClick={() => handleChangeOrder(property)}
		>
			{!(method === "desc") && <FaChevronUp size={10} />}
			{!(method === "asc") && <FaChevronDown size={10} />}
		</button>
	);
}
